import { makeStyles } from '@material-ui/core/styles';
import { ui } from '../../../shared/insightUi';

function StatsCard({ value, label, iconSrc }) {
  const classes = useStyles();
  const display = value === undefined || value === null || value === '' ? '–' : value;
  return (
    <div className={classes.tile} title={label}>
      <div className={classes.iconBox}>
        <img src={iconSrc} className={classes.icon} alt="" />
      </div>
      <div className={classes.textCol}>
        <div className={classes.value}>{display}</div>
        <div className={classes.label}>{label}</div>
      </div>
    </div>
  );
}

const useStyles = makeStyles(() => ({
  // Fixed footprint on purpose: the tile never stretches or inherits height,
  // so wrapping to a new line can only grow the parent, never overlap.
  tile: {
    boxSizing: 'border-box',
    width: 186,
    minHeight: 60,
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    background: ui.tileBg,
    border: `1px solid ${ui.border}`,
    borderRadius: 10,
    padding: '10px 14px',
    fontFamily: ui.font,
    transition: 'border-color 160ms ease, box-shadow 160ms ease',
    '&:hover': {
      borderColor: '#C7CDE0',
      boxShadow: '0 2px 8px rgba(16, 24, 40, 0.06)',
    },
  },
  iconBox: {
    boxSizing: 'border-box',
    width: 30,
    height: 30,
    flex: '0 0 auto',
    borderRadius: 8,
    background: '#FFFFFF',
    border: `1px solid ${ui.border}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    width: 14,
  },
  textCol: {
    minWidth: 0,
  },
  value: {
    fontSize: 15,
    fontWeight: 800,
    color: ui.ink,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  label: {
    fontSize: 11,
    fontWeight: 600,
    color: ui.inkFaint,
    marginTop: 2,
    lineHeight: 1.3,
  },
}));

export default StatsCard;
